import React, { useState, useEffect, useContext } from 'react';
import { LogOut, ChevronLeft, Search } from 'lucide-react';
import { useNavigate, useParams } from 'react-router-dom';
import { AppContext } from '../../App';
import { useAuth } from '../../contexts/AuthContext';
import { getDisplayName } from '../../utils/displayName';
import { adminAPI } from '../../services/api';
import { paymentStatusBadgeClass } from '../../utils/paymentStatus';
import { toast } from 'react-toastify';

const ExternalUnitProperties = () => {
  const { unit } = useParams();
  const navigate = useNavigate();
  const { logout } = useContext(AppContext);
  const { user } = useAuth();
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [q, setQ] = useState('');

  useEffect(() => {
    let c = false;
    (async () => {
      try {
        const data = await adminAPI.getCollectionUnitProperties(unit);
        if (!c) setRows(Array.isArray(data) ? data : []);
      } catch {
        if (!c) {
          toast.error('Failed to load properties');
          setRows([]);
        }
      } finally {
        if (!c) setLoading(false);
      }
    })();
    return () => { c = true; };
  }, [unit]);

  const qq = q.toLowerCase().trim();
  const filtered = rows.filter((r) => {
    if (!qq) return true;
    const s = [r.valuation_no, r.bill_no, r.owner_name].join(' ').toLowerCase();
    return s.includes(qq);
  });

  return (
    <div className="h-full flex flex-col">
      <header className="p-6 bg-gradient-to-r from-[#001E3C] to-[#000B18] border-b border-white/10">
        <div className="flex items-center gap-3 mb-4">
          <button type="button" onClick={() => navigate('/external/collection-units')} className="glass-card p-3 rounded-xl">
            <ChevronLeft className="w-5 h-5 text-white" />
          </button>
          <div className="flex-1">
            <h2 className="text-xl font-black uppercase text-white">Unit {unit}</h2>
            <p className="text-xs text-white/60">{user ? getDisplayName(user) : '—'}</p>
          </div>
          <button type="button" onClick={() => logout && logout()} className="glass-card p-3 rounded-xl">
            <LogOut className="w-5 h-5 text-white" />
          </button>
        </div>
        <div className="relative">
          <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-5 h-5 text-white/50" />
          <input
            type="text"
            value={q}
            onChange={(e) => setQ(e.target.value)}
            placeholder="Search valuation, bill, owner..."
            className="w-full pl-10 pr-4 py-3 bg-white/5 border border-white/10 rounded-xl text-white placeholder-white/40 outline-none"
          />
        </div>
      </header>
      <main className="flex-1 overflow-y-auto p-6 no-scrollbar">
        {loading ? (
          <p className="text-white/60">Loading...</p>
        ) : (
          <div className="space-y-3">
            {filtered.map((r) => (
              <button
                key={r.id}
                type="button"
                onClick={() => navigate('/external/property/' + r.id)}
                className="w-full text-left glass-card p-4 border-l-4 border-[#7E57C2] active:scale-[0.99] transition-transform"
              >
                <p className="text-white font-bold">{r.valuation_no}</p>
                <p className="text-xs text-white/50">{r.owner_name || '—'}</p>
                <p className="text-xs text-white/60 mt-1">
                  Bill {Number(r.bill_amount).toLocaleString()} · Paid {Number(r.total_paid).toLocaleString()}
                </p>
                <span className={'inline-block mt-2 px-2 py-0.5 rounded-lg text-[10px] font-black uppercase border ' + paymentStatusBadgeClass(r.payment_status)}>
                  {r.payment_status?.replace(/_/g, ' ')}
                </span>
              </button>
            ))}
          </div>
        )}
      </main>
    </div>
  );
};

export default ExternalUnitProperties;
